import { AiFillLinkedin, AiOutlineInstagram } from "react-icons/ai";
import "./FooterStyle.css";
import { FaFacebook, FaTiktok } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { Accordion, useAccordionButton } from "react-bootstrap";
import { useEffect, useState } from "react";
import { MdConstruction, MdLocationOn } from "react-icons/md";
import Loader from "../loader/Loader";
import { Link } from "react-router-dom";
import { BiLogoTiktok } from "react-icons/bi";
import { RxLinkedinLogo } from "react-icons/rx";
import seoData from "../../content/seoSitemapData.json";
import { trackSocialClick } from "../../services/socialClicksService";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../config/FirebaseConfig";
import {
  DEFAULT_PROMO_TERMS,
  PROMO_TERMS_DOC_PATH,
} from "../../config/promoTermsConfig";

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, () => {});

  return (
    <span className="footer-subtitle" onClick={decoratedOnClick}>
      {children}
    </span>
  );
}

export default function FooterComponent() {
  const [showTooltipChip, setShowTooltipChip] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [showStreamingList, setShowStreamingList] = useState(false);
  const [promotionName, setPromotionName] = useState(
    DEFAULT_PROMO_TERMS.promotionName,
  );
  const cnpjValue = "12.041.618/0001-89";
  const addressStreet = "Rua Waldomiro Correia Neto, 956";
  const addressDistrict = "Jardim Alexandrina";
  const addressCity = "Anápolis - GO";
  const addressPostal = "CEP 75060-473";
  const addressMapUrl = "https://maps.app.goo.gl/8DDEZ2r2H3EvCEWGA";
  const featuredStreamingSlugs = ["disney-plus", "hbo-max", "globoplay"];
  const featuredStreamings = featuredStreamingSlugs
    .map((slug) => seoData.streamings.find((item) => item.slug === slug))
    .filter(Boolean);
  const otherStreamings = seoData.streamings.filter(
    (item) => !featuredStreamingSlugs.includes(item.slug),
  );
  const cityLinks = seoData.cities || [];
  const cityGroups = cityLinks.reduce((acc, city) => {
    const stateKey = city.state || "OUTROS";
    if (!acc[stateKey]) {
      acc[stateKey] = [];
    }
    acc[stateKey].push(city);
    return acc;
  }, {});
  const stateLabels = { GO: "GOIÁS", DF: "DF" };
  const orderedStates = ["GO", "DF"];
  const cityStates = [
    ...orderedStates.filter((state) => (cityGroups[state] || []).length > 0),
    ...Object.keys(cityGroups).filter(
      (state) => !orderedStates.includes(state),
    ),
  ];
  const renderCityGroups = () =>
    cityStates.map((state) => (
      <div className="footer-city-group" key={state}>
        <span className="footer-city-group-title">
          {stateLabels[state] || state}
        </span>
        {cityGroups[state].map((city) => (
          <Link
            className="footer-subtitle"
            to={`/internet-fibra-${city.slug}`}
            key={city.slug}
          >
            {city.name}
          </Link>
        ))}
      </div>
    ));

  useEffect(() => {
    const loadPromotionName = async () => {
      try {
        const docRef = doc(
          db,
          PROMO_TERMS_DOC_PATH.collection,
          PROMO_TERMS_DOC_PATH.id,
        );
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const promoTerms = docSnap.data();
          setPromotionName(
            promoTerms.footerPromotionName ||
              promoTerms.promotionName ||
              DEFAULT_PROMO_TERMS.footerPromotionName,
          );
        }
      } catch (error) {
        console.error("Erro ao carregar nome da promoção:", error);
      }
    };

    loadPromotionName();
  }, []);

  // Ao voltar da rede social (botão voltar do celular), a página volta do cache
  // com o estado antigo; esconde o loader para ele não ficar preso na tela.
  useEffect(() => {
    const handlePageShow = () => setLoading(false);
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  async function handleSocialClick(social) {
    setLoading(true);
    try {
      await trackSocialClick(social);
      switch (social) {
        case "tiktok":
          window.location.href = "https://www.tiktok.com/@settefibra";
          break;

        case "linkedin":
          window.location.href =
            "https://www.linkedin.com/company/sette-fibra/";
          break;
        case "facebook":
          window.location.href = "https://www.facebook.com/SETTEFIBRA/";
          break;
        case "instagram":
          window.location.href = "https://www.instagram.com/settefibra/";
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Error tracking social click:", error);
    }
    return Promise.resolve();
  }

  const toggleStreamingList = () => {
    setShowStreamingList((prev) => !prev);
  };

  return (
    <>
      {isLoading && <Loader />}
      <footer className="site-footer">
        <div className="footer-shell desktop">
          <div className="footer-brand h-card">
            <img
              alt="Logo da Sette Fibra"
              src="/assets/logo/SETTE-FIBRA2.png"
              className="se77e-logo u-logo"
            />

            <h2 className="marketing1 p-note">
              Uma fibra. Sette possibilidades.
            </h2>
            <div className="icons-footer">
              <span
                onClick={() => {
                  handleSocialClick("instagram").then(() => {
                    setLoading(false);
                  });
                }}
                style={{ textDecoration: "none", color: "#fff" }}
              >
                <AiOutlineInstagram className="icon" />
              </span>
              <span
                onClick={() => {
                  handleSocialClick("tiktok").then(() => {
                    setLoading(false);
                  });
                }}
                style={{ textDecoration: "none", color: "#fff" }}
              >
                <BiLogoTiktok className="icon" />
              </span>
              <span
                onClick={() => {
                  handleSocialClick("linkedin").then(() => {
                    setLoading(false);
                  });
                }}
                style={{ textDecoration: "none", color: "#fff" }}
              >
                <RxLinkedinLogo className="icon" />
              </span>
              <span
                onClick={() => {
                  handleSocialClick("facebook").then(() => {
                    setLoading(false);
                  });
                }}
                style={{ textDecoration: "none", color: "#fff" }}
              >
                <FaFacebook className="icon" />
              </span>
            </div>
            <div className="footer-meta">
              <div className="footer-info-card">
                <div className="footer-cnpj">
                  <span className="footer-cnpj-label">CNPJ</span>
                  <span className="footer-cnpj-value">{cnpjValue}</span>
                </div>
                <a
                  className="footer-address p-adr"
                  href={addressMapUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="footer-address-icon" aria-hidden="true">
                    <MdLocationOn />
                  </span>
                  <span className="footer-address-text">
                    <span className="footer-address-label">Endereco</span>
                    <span className="footer-address-line">{addressStreet}</span>
                    <span className="footer-address-line">
                      {addressDistrict} - {addressCity}
                    </span>
                    <span className="footer-address-line">{addressPostal}</span>
                  </span>
                </a>
              </div>
            </div>
          </div>

          <div className="footer-columns">
            <div className="footer-col">
              <h2 className="footer-title">Vantagens</h2>
              <div className="footer-links">
                <div
                  className="footer-tooltip"
                  onMouseEnter={() => setShowTooltipChip(true)}
                  onMouseLeave={() => setShowTooltipChip(false)}
                  onClick={() => setShowTooltipChip((prev) => !prev)}
                >
                  <span className="footer-subtitle">
                    <h6 style={{ textDecoration: "none", fontSize: 14 }}>
                      SETTE Chip
                    </h6>
                  </span>
                  <span
                    className={`tooltip-construction ${
                      showTooltipChip ? "show-tooltip" : ""
                    }`}
                  >
                    Em Breve <MdConstruction />
                  </span>
                </div>
                <div className="footer-streaming-block">
                  <div className="footer-streaming-links">
                    {featuredStreamings.map((streaming) => (
                      <Link
                        className="footer-subtitle"
                        to={`/streaming/${streaming.slug}`}
                        key={streaming.slug}
                      >
                        {streaming.name}
                      </Link>
                    ))}
                  </div>
                  <div className="footer-streaming-toggle">
                    <button
                      type="button"
                      className={`footer-subtitle footer-streaming-button ${
                        showStreamingList ? "open" : ""
                      }`}
                      onClick={toggleStreamingList}
                    >
                      Streamings{" "}
                      <IoIosArrowDown className="footer-streaming-icon" />
                    </button>
                    <div
                      className={`footer-streaming-list ${
                        showStreamingList ? "open" : ""
                      }`}
                    >
                      {otherStreamings.map((streaming) => (
                        <Link
                          key={streaming.slug}
                          className="footer-subtitle"
                          to={`/streaming/${streaming.slug}`}
                          onClick={() => setShowStreamingList(false)}
                        >
                          {streaming.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-col">
              <h2 className="footer-title">Atendimento</h2>
              <div className="footer-links">
                <Accordion defaultActiveKey="1">
                  <CustomToggle eventKey="0">
                    <h6 style={{ fontSize: 14, cursor: "pointer" }}>
                      E-mail <IoIosArrowDown />
                    </h6>
                  </CustomToggle>
                  <Accordion.Collapse eventKey="0">
                    <a
                      className="footer-subtitle2 u-email"
                      href="mailto:info@settefibra.com.br"
                    >
                      <h6 style={{ fontSize: 14 }}>info@settefibra.com.br</h6>
                    </a>
                  </Accordion.Collapse>
                </Accordion>

                <a
                  className="footer-subtitle"
                  target="_blank"
                  rel="noreferrer"
                  href="https://api.whatsapp.com/send?phone=556240519377"
                >
                  WhatsApp
                </a>
              </div>
            </div>

            <div className="footer-col">
              <h2 className="footer-title">Internet</h2>
              <div className="footer-links">
                <Link className="footer-subtitle" to={"/internet-anapolis"}>
                  <h6 style={{ fontSize: 14 }}>Internet em Anápolis</h6>
                </Link>
                <Link
                  className="footer-subtitle"
                  to={"/internet-residencial-anapolis"}
                >
                  <h6 style={{ fontSize: 14 }}>Internet Residencial</h6>
                </Link>
                <Link
                  className="footer-subtitle"
                  to={"/internet-empresarial-anapolis"}
                >
                  <h6 style={{ fontSize: 14 }}>Internet Empresarial</h6>
                </Link>
                <Link
                  className="footer-subtitle"
                  to={"/provedor-internet-anapolis"}
                >
                  <h6 style={{ fontSize: 14 }}>Provedor em Anápolis</h6>
                </Link>
              </div>
            </div>

            <div className="footer-col">
              <h2 className="footer-title">Informações</h2>
              <div className="footer-links">
                <Link className="footer-subtitle" to={"/compliance"}>
                  <h6 style={{ fontSize: 14 }}>Compliance</h6>
                </Link>
                <Link className="footer-subtitle" to={"/blog"}>
                  <h6 style={{ fontSize: 14 }}>Blog</h6>
                </Link>
                <Link className="footer-subtitle" to={"/terms/privacy-policy"}>
                  <h6 style={{ fontSize: 14 }}>Política</h6>
                </Link>
                <Link
                  className="footer-subtitle"
                  to={"/terms/terms-and-conditions"}
                >
                  <h6 style={{ fontSize: 14 }}>Termos</h6>
                </Link>
                <Link
                  className="footer-subtitle"
                  to={"/terms/terms-and-conditions/promo"}
                >
                  <h6 style={{ fontSize: 14 }}>
                    Termo Promoção <br />
                    {promotionName}
                  </h6>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-shell mobile">
          <div className="footer-brand h-card">
            <img
              alt="Logo da Sette Fibra"
              src="/assets/logo/SETTE-FIBRA2.png"
              className="se77e-logo u-logo"
            />

            <h3 className="marketing1 p-note">
              Uma fibra. Sette possibilidades.
            </h3>
            <div className="footer-info-card">
              <div className="footer-cnpj">
                <span className="footer-cnpj-label">CNPJ</span>
                <span className="footer-cnpj-value">{cnpjValue}</span>
              </div>
              <a
                className="footer-address p-adr"
                href={addressMapUrl}
                target="_blank"
                rel="noreferrer"
              >
                <span className="footer-address-icon" aria-hidden="true">
                  <MdLocationOn />
                </span>
                <span className="footer-address-text">
                  <span className="footer-address-label">Endereco</span>
                  <span className="footer-address-line">{addressStreet}</span>
                  <span className="footer-address-line">
                    {addressDistrict} - {addressCity}
                  </span>
                  <span className="footer-address-line">{addressPostal}</span>
                </span>
              </a>
            </div>
            <div className="icons-footer">
              <span
                onClick={() => {
                  handleSocialClick("instagram");
                }}
                style={{ textDecoration: "none", color: "#fff" }}
              >
                <AiOutlineInstagram className="icon" />
              </span>
              <span
                onClick={() => {
                  handleSocialClick("tiktok");
                }}
                style={{ textDecoration: "none", color: "#fff" }}
              >
                <FaTiktok className="icon" />
              </span>
              <span
                onClick={() => {
                  handleSocialClick("linkedin");
                }}
                style={{ textDecoration: "none", color: "#fff" }}
              >
                <AiFillLinkedin className="icon" />
              </span>
              <span
                onClick={() => {
                  handleSocialClick("facebook");
                }}
                style={{ textDecoration: "none", color: "#fff" }}
              >
                <FaFacebook className="icon" />
              </span>
            </div>
          </div>

          <div className="footer-columns">
            <div className="footer-col">
              <h2 className="footer-title">Vantagens</h2>
              <div className="footer-links">
                <div
                  className="footer-tooltip"
                  onMouseEnter={() => setShowTooltipChip(true)}
                  onMouseLeave={() => setShowTooltipChip(false)}
                  onClick={() => setShowTooltipChip((prev) => !prev)}
                >
                  <span className="footer-subtitle">
                    <h4 style={{ fontSize: 14 }}>Sette Chip</h4>
                  </span>
                  <span
                    className={`tooltip-construction ${
                      showTooltipChip ? "show-tooltip" : ""
                    }`}
                  >
                    Em Breve <MdConstruction />
                  </span>
                </div>
                <div className="footer-streaming-block">
                  <div className="footer-streaming-links">
                    {featuredStreamings.map((streaming) => (
                      <Link
                        className="footer-subtitle"
                        to={`/streaming/${streaming.slug}`}
                        key={streaming.slug}
                      >
                        {streaming.name}
                      </Link>
                    ))}
                  </div>
                  <div className="footer-streaming-toggle">
                    <button
                      type="button"
                      className={`footer-subtitle footer-streaming-button ${
                        showStreamingList ? "open" : ""
                      }`}
                      onClick={toggleStreamingList}
                    >
                      Streamings{" "}
                      <IoIosArrowDown className="footer-streaming-icon" />
                    </button>
                    <div
                      className={`footer-streaming-list ${
                        showStreamingList ? "open" : ""
                      }`}
                    >
                      {otherStreamings.map((streaming) => (
                        <Link
                          key={streaming.slug}
                          className="footer-subtitle"
                          to={`/streaming/${streaming.slug}`}
                          onClick={() => setShowStreamingList(false)}
                        >
                          {streaming.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-col">
              <h2 className="footer-title">Atendimento</h2>
              <div className="footer-links">
                <Accordion defaultActiveKey="1">
                  <CustomToggle eventKey="0">
                    E-mail <IoIosArrowDown />
                  </CustomToggle>
                  <Accordion.Collapse eventKey="0">
                    <a
                      className="footer-subtitle2 u-email"
                      href="mailto:info@settefibra.com.br"
                    >
                      info@settefibra.com.br
                    </a>
                  </Accordion.Collapse>
                </Accordion>

                <a
                  className="footer-subtitle"
                  href="https://api.whatsapp.com/send?phone=556240519377"
                  rel="noreferrer"
                >
                  WhatsApp
                </a>
              </div>
            </div>

            <div className="footer-col">
              <span className="footer-title">Internet</span>
              <div className="footer-links">
                <Link className="footer-subtitle" to={"/internet-anapolis"}>
                  Internet em Anápolis
                </Link>
                <Link
                  className="footer-subtitle"
                  to={"/internet-residencial-anapolis"}
                >
                  Internet Residencial
                </Link>
                <Link
                  className="footer-subtitle"
                  to={"/internet-empresarial-anapolis"}
                >
                  Internet Empresarial
                </Link>
                <Link
                  className="footer-subtitle"
                  to={"/provedor-internet-anapolis"}
                >
                  Provedor em Anápolis
                </Link>
              </div>
            </div>

            <div className="footer-col">
              <span className="footer-title">Informações</span>
              <div className="footer-links">
                <Link className="footer-subtitle" to={"/compliance"}>
                  Compliance
                </Link>
                <Link className="footer-subtitle" to={"/blog"}>
                  Blog
                </Link>
                <Link className="footer-subtitle" to={"/terms/privacy-policy"}>
                  Política
                </Link>
                <Link
                  className="footer-subtitle"
                  to={"/terms/terms-and-conditions"}
                >
                  Termos
                </Link>
                <Link
                  className="footer-subtitle"
                  to={"/terms/terms-and-conditions/promo"}
                >
                  Termo Promoção <br />
                  {promotionName}
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-retangle-line"></div>
          <div className="rights-reserved">
            © 2026 SETTE. All rights reserved.
          </div>
        </div>
      </footer>
    </>
  );
}
